export const AttachmentBlock = {
    block(block) {
        return {
            name: 'Attachment',
            fields: block.fields ?? [],
            files: block.files ?? [],
            type: 'attachment',
            uuid: block.uuid ?? 0,
            lock: block.lock ?? 0,
            connected_parent_conditional_id: block.connected_parent_conditional_id ?? [],
            attachment_name: block.attachment_name ?? 'attachment',
            request_from: block.request_from ?? 0,
            uploading_is : block.uploading_is ?? 0,
            allow_multiple: block.allow_multiple ?? false,
            reusable: block.reusable ?? 0,
            viewing_is: block.viewing_is ?? 0,
            viewed_by: [],
        }
    }
}